module.exports = __webpack_public_path__ + "img/lb1.6b05a88a.jpg";